import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { LOADING_STYLES } from '@components/main-components/skeleton/Skeleton';

export const UserInfoSkeleton = () => {
  return (
    <SkeletonContainer>
      <Skeleton variant="image" />
      <SkeletonNameWrapper>
        <Skeleton variant="name" />
        <Skeleton variant="address" />
      </SkeletonNameWrapper>
    </SkeletonContainer>
  );
};

const SkeletonContainer = styled('div', {
  display: 'flex',
  gap: 12,
});

const Skeleton = styled('div', {
  ...LOADING_STYLES,
  variants: {
    variant: {
      image: {
        height: 48,
        width: 48,
      },
      name: {
        height: 18,
        width: 200,
      },
      address: {
        height: 16,
        width: 60,
      },
    },
  },
  borderRadius: 6,
});

const SkeletonNameWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
});
